import { ApiManager } from './index';
import {
  DoublePurchaseValidationResult,
  DynamicDoublePurchaseValidationResult,
  PaymentCycle,
  ProductTypeIds,
} from '../utils';

export const CheckoutUrls = {
  CLASSIC_ORDER_PAGE_DATA: '/store/v2/plans/createOrderPage',
  DYNAMIC_OFFERING_ORDER_PAGE_DATA: '/_api/premium-store/v1/createOrderPage',
  GET_ASSIGNED_DOMAINS: '/_api/my-domains/v1/domains/assigned',
  SHOULD_SUGGEST_REASSIGN:
    '/_serverless/premium-manage-premium-assets/shouldSuggestReassign',
  DYNAMIC_VERIFY_DOUBLE_PURCHASE:
    '/_api/premium-store/v1/ValidateNoPreviousPurchase',
  VERIFY_DOUBLE_PURCHASE: '/store/verifyPlansDoublePurchase',
};

type ReassignStatus = boolean | string | undefined;

interface IsRepurchaseRequest {
  metaSiteId: string;
}

interface IsRepurchaseResponse {
  reassignStatus?: ReassignStatus;
}

export interface ClassicDoublePurchaseRequest {
  siteGuid: string;
  appDefId: number;
  eventAggregator: string;
  paymentCycle: PaymentCycle;
  productId: number;
  upgrade: boolean;
}

export interface ClassicDoublePurchaseResponse {
  success: boolean;
  validationCode: DoublePurchaseValidationResult;
  existingPackageInfo: {
    planName: string;
    cycle: PaymentCycle;
    conflictingServiceGuid: string;
  } | null; // if server cannot check in SBS for duplicate package returns null
}

interface DynamicDoublePurchaseRequest {
  productTypeId: string;
  msid: string;
}

interface DynamicDoublePurchaseResponse {
  status: DynamicDoublePurchaseValidationResult;
}

function verifyDynamicDoublePurchase(
  siteGuid: string,
): Promise<DynamicDoublePurchaseResponse> {
  const productTypeId = ProductTypeIds.PremiumPlans;
  return ApiManager.post<
    DynamicDoublePurchaseRequest,
    DynamicDoublePurchaseResponse
  >(CheckoutUrls.DYNAMIC_VERIFY_DOUBLE_PURCHASE, {
    productTypeId,
    msid: siteGuid,
  });
}

async function fetchIsRepurchase(
  params: IsRepurchaseRequest,
): Promise<ReassignStatus> {
  const response = await ApiManager.post<
    IsRepurchaseRequest,
    IsRepurchaseResponse
  >(CheckoutUrls.SHOULD_SUGGEST_REASSIGN, params);
  return response.reassignStatus;
}

export const CheckoutApi = {
  fetchIsRepurchase,
  verifyDynamicDoublePurchase,
};
